<div class="PolicyDashboard">
    <!-- <div class="Loading" *ngIf="isShowLoading==true">
        <img id="" src="assets/img/762.gif" />
        <label class="loadertext">{{'Please Wait,Processing..'|translate }}</label>
    </div> -->

    <div class="Loading" *ngIf="isShowLoading==true">
        <div class="loader"></div>
        <!-- <img id="" src="assets/img/762.gif"   /> -->
        <label class="loaderlabel">Please wait while Processing....</label>
    </div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-2 col-md-2 hidden-sm hidden-xs"></div>
            <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                <div class="col-md-12 proposals">
                    <div class="panel panel-default panel-table">
                        <div class="panel-heading">
                            <div class="row">
                                <div class="col col-xs-6">
                                    <h3 class="panel-title">{{'Upgrade Policy'|translate }}</h3>
                                </div>
                            </div>
                        </div>
                        <div class="panel-body">
                            <form #upgradepolicyform="ngForm">
                                <div class="PaymentForm paymentFormUpgrade">
                                    <div class="row">
                                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 arabicfieldarrange">
                                            <label>{{'PolicyNo' | translate }}</label>
                                        </div>
                                        <div class="col-lg-9 col-md-9 col-sm-9 col-xs-12">
                                            <input type="text" class="form-control" [disabled]="true" name="txtPolicyNo" id="txtPolicyNo"
                                            [(ngModel)]="objBindInfoRes.PolicyNo">
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 arabicfieldarrange">
                                            <label>{{'Name' | translate }}</label>
                                        </div>
                                        <div class="col-lg-9 col-md-9 col-sm-9 col-xs-12">
                                            <input type="text" class="form-control" [disabled]="true" name="txtName" id="txtName"
                                            [(ngModel)]="objBindInfoRes.InsuredName">
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 arabicfieldarrange">
                                            <label>{{'Iqama/ID No' | translate }}</label>
                                        </div>
                                        <div class="col-lg-9 col-md-9 col-sm-9 col-xs-12">
                                            <input type="text" class="form-control" [disabled]="true" name="txtIqama" id="txtIqama"
                                            [(ngModel)]="objBindInfoRes.Insured_IdNo">
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 arabicfieldarrange">
                                            <label>{{'Sequence No / Custom ID' | translate }}</label>
                                        </div>
                                        <div class="col-lg-9 col-md-9 col-sm-9 col-xs-12">
                                            <input type="text" class="form-control" (keypress)="ValidateSpecialChar($event)" numbersOnly maxlength="9" minlength="6" name="txtSeq"
                                            #txtSeq id="txtSeq" [(ngModel)]="objBindInfoRes.VehicleId" [disabled]="true">
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 arabicfieldarrange">
                                            <label>{{'Deductible Type' | translate }}</label>
                                        </div>
                                        <div class="col-lg-9 col-md-9 col-sm-9 col-xs-12">
                                            <select  [(ngModel)]="objBindInfoRes.DeductableType" required selectRequired  class="form-control"  name="txtDeduc" id="txtDeduc" #txtDeduc="ngModel">
                                                <option value="0">--{{ 'Select Deductable'| translate}}--</option>
                                                <option *ngFor="let deduc of objBindInfoRes.deductableList" [value]="deduc.DeductableCode">{{deduc.DeductableDescEn}}</option>
                                            </select>
                                            <span *ngIf="(txtDeduc.invalid && txtDeduc.dirty)" class="text-danger valid">
                                                <div *ngIf="txtDeduc.errors?.required">
                                                    {{ 'Deductable is required'| translate}}
                                                </div>
                                                <div *ngIf="txtDeduc.errors?.selectRequired">
                                                    {{ 'Deductable is required'| translate}}
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 arabicfieldarrange">
                                            <label>{{'Repair Type' | translate }}</label>
                                        </div>
                                        <div class="col-lg-9 col-md-9 col-sm-9 col-xs-12">
                                            <select [(ngModel)]="objBindInfoRes.RepairType" class="form-control" selectRequired name="txtRepair" id="txtRepair" required #txtRepair="ngModel">
                                                <option value="0">--{{ 'Select Repair Type' | translate}}--</option>
                                                <option *ngFor="let repair of objBindInfoRes.repairList" [value]="repair.AgencyCode">{{ Lng=="en"?repair.AgencyDescEn: repair.AgencyDescAr }}</option>
                                            </select>
                                            <span *ngIf="txtRepair.invalid && txtRepair.dirty" class="text-danger valid">
                                                <div *ngIf="txtRepair.errors.required">
                                                    {{'Repair Type is required'| translate}}
                                                </div>
                                                <div *ngIf="txtRepair.errors?.selectRequired">
                                                    {{ 'Repair Type is required'| translate}}
                                                </div>
                
                                            </span>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 arabicfieldarrange">
                                            <label>{{'Sum Insured' | translate }}</label>
                                        </div>
                                        <div class="col-lg-9 col-md-9 col-sm-9 col-xs-12">
                                            <input type="text" class="form-control"  name="txtSum" autocomplete="off" id="txtSum" [(ngModel)]="objBindInfoRes.SumInsured" 
                                            numbersOnly required #txtSum="ngModel" maxlength="6" [customMin]="objBindInfoRes.MinSumInsured" 
                                            [customMax]="objBindInfoRes.MaxSumInsured" (keypress)="ValidateSpecialChar($event)">
                                      
                                            <span *ngIf="txtSum.invalid && txtSum.dirty" class="text-danger valid">
                                                <div *ngIf="txtSum.errors.required">
                                                    {{ 'SumInsured is required'| translate}}<br/>
                                                    {{ 'Sum insured must be between' | translate }} {{objBindInfoRes.MinSumInsured}} - {{objBindInfoRes.MaxSumInsured}}
                                                </div>
                                                <div *ngIf="txtSum.errors?.customMin">
                                                    {{ 'SumInsured must be greater than'| translate}} {{ objBindInfoRes.MinSumInsured }}
                                                </div>
                                                <div *ngIf="txtSum.errors?.customMax">
                                                        {{ 'SumInsured must be less than'| translate}}  {{ objBindInfoRes.MaxSumInsured}}
                                                </div>
                                            </span>
                                        </div>
                                    </div>


                                    <div class="row">
                                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 arabicfieldarrange">
                                            <label>{{'Plate Number' | translate }}</label>
                                        </div>
                                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 platenoarabic">
                                            <input type="text" class="form-control" [disabled]="true" name="txtplateNo" id="txtMake"
                                            [(ngModel)]="objBindInfoRes.Vehicle_PlateNo">
                                        </div>
                                        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 platenoarabic">
                                            <input type="text" class="form-control" [disabled]="true" name="txtplate1"  id="txtplate1"
                                            [(ngModel)]="Lng=='en'?objBindInfoRes.Vehicle_Fletter_En: objBindInfoRes.Vehicle_Fletter_Ar">
                                        </div>
                                        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 platenoarabic">
                                            <input type="text" class="form-control" [disabled]="true" name="txtplate2" id="txtplate2"
                                            [(ngModel)]="Lng=='en'?objBindInfoRes.Vehicle_Sletter_En: objBindInfoRes.Vehicle_Sletter_Ar">
                                        </div>
                                        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 platenoarabic">
                                            <input type="text" class="form-control" [disabled]="true" name="txtplate3" id="txtplate3"
                                            [(ngModel)]="Lng=='en'?objBindInfoRes.Vehicle_Tletter_En: objBindInfoRes.Vehicle_Tletter_Ar">
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div  class="col-lg-3 col-md-3 col-sm-3 col-xs-12 arabicfieldarrange">
                                            <label>{{'Make' | translate }}</label>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                            <input type="text" class="form-control" [disabled]="true" name="txtMake" id="txtMake"
                                            [(ngModel)]="Lng=='en'?objBindInfoRes.Make_En: objBindInfoRes.Make_Ar">
                                        </div>

                                        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 arabicfieldarrange">
                                            <label>{{'Model' | translate }}</label>
                                        </div>
                                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                            <input type="text" class="form-control" [disabled]="true" name="txtModel" id="txtodel"
                                            [(ngModel)]="Lng=='en'?objBindInfoRes.Model_En: objBindInfoRes.Model_Ar">
                                        </div>
                                    </div>
<!-- 
                                    <div class="row">
                                        <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 arabicfieldarrange">
                                            <label>{{'Model' | translate }}</label>
                                        </div>
                                        <div class="col-lg-9 col-md-9 col-sm-9 col-xs-12">
                                            <input type="text" class="form-control" [disabled]="true" name="txtModel" id="txtodel"
                                            [(ngModel)]="Lng=='en'?objBindInfoRes.Model_En: objBindInfoRes.Model_Ar">
                                        </div>
                                    </div> -->


                                    <div class="row formbuttons">
                                        <button class="btn btn-primary btn-block upgradebtn" name="btnProceed" id="btnProceed" type="submit" 
                                        [disabled]="upgradepolicyform.form.invalid || objBindInfoRes.DeductableType=='0' " 
                                        (click)="ProceedToUpgrade(upgradepolicyform.valid)">{{'Upgrade Policy' | translate }}</button>	
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-2 hidden-sm hidden-xs"></div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/Upgrade/Upgrade.html